import { useState } from "react";

import Modal from "ui-components/Modal";
import Button from "ui-components/Button";
import Divider from "ui-components/Divider";
import InputField from "ui-components/Input-Field";
import FilterSummary from "ui-components/Data-Filters/Filter-Summary";

import FileFilters from "modules/data-files/elements/File-Filters";

import {
  useGetInputFile,
  useYDefinition,
  useYOnesTag,
  useYZerosTag,
} from "./store";

const setYDefinitions = () => {
  const currentFile = useGetInputFile();

  const [showModal, setShowModal] = useState(false);

  const [yDefinition, setYDefinition] = useYDefinition();
  const resetOutcome = () => setYDefinition([]);

  const [zerosTag, setZerosTag] = useYZerosTag();
  const [onesTag, setOnesTag] = useYOnesTag();

  const [view, setView] = useState<"filters" | "tags">("filters");

  return (
    <div className="flex">
      <div className="w-1/4">
        <p className="font-bold">2. Define Outcome:</p>
      </div>
      <div className="w-full">
        {yDefinition?.length >= 1 ? (
          <div className="pl-2 ml-2">
            <p>
              Rows meeting ALL the below conditions are going to be tagged as{" "}
              <span className="font-semibold underline">{onesTag}: </span>{" "}
            </p>
            <ul className="list-decimal ml-2 pl-2 list-inside">
              {yDefinition.map((d, i) => (
                <li key={i} className="ml-2 pl-2">
                  <FilterSummary filter={d} />
                </li>
              ))}
            </ul>
            <p>
              All other rows shall be marked as{" "}
              <span className="font-semibold underline">{zerosTag}</span>
            </p>
            <p className="mt-2">
              Click{" "}
              <span
                onClick={() => {
                  setShowModal(true);
                  setView("filters");
                }}
                className="uppercase text-primary-main cursor-pointer underline"
              >
                here
              </span>{" "}
              to change/edit group definitions, and{" "}
              <span
                onClick={() => {
                  setView("filters");
                  resetOutcome();
                }}
                className="uppercase text-primary-main cursor-pointer underline"
              >
                here
              </span>{" "}
              to reset
            </p>
          </div>
        ) : (
          <p className="text-center pt-2">
            <span
              className="underline text-primary-main cursor-pointer"
              onClick={() => setShowModal(true)}
            >
              Click here
            </span>{" "}
            to define the groups.
          </p>
        )}
        <Modal
          show={showModal}
          handleClose={() => setShowModal(false)}
          id="define-groups"
          ariaLabel="define-groups"
          title="Define groups"
        >
          {view === "filters" ? (
            <div>
              <p className="text-xl font-bold">Setup Outcome Definitions</p>
              <p className="help">
                Rows that meet ALL the conditions you set are going to be tagged
                as successes (1s). And the rest are failures (0s).
              </p>

              <FileFilters
                fileId={currentFile}
                filters={yDefinition}
                updateFilters={setYDefinition}
                className="m-2 p-2"
              />
              <Divider />
              <p className="text-right">
                <Button
                  disabled={yDefinition.length === 0}
                  onClick={() => setView("tags")}
                >
                  Set Tags
                </Button>
              </p>
            </div>
          ) : (
            <div>
              <InputField<string>
                type="text"
                name="tag_ones"
                label="Tag for Meeting All Conditions"
                required
                value={onesTag || ""}
                onChange={setOnesTag}
                help="What do you want to tag successes?."
              />
              <InputField<string>
                type="text"
                name="tag_zeros"
                label="Tag for Other Rows"
                required
                value={zerosTag || ""}
                onChange={setZerosTag}
                help="What do you want to tag all other rows?"
              />
              <Divider />
              <p className="text-right">
                <Button
                  disabled={!zerosTag || !onesTag}
                  onClick={() => setShowModal(false)}
                >
                  Close
                </Button>
              </p>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default setYDefinitions;
